module.exports = __webpack_public_path__ + "static/media/album-picker.0cf94250.svg";